function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null
  }

  return value as Record<string, unknown>
}

function normalizeAiWatermarkValue(value: unknown) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    if (value === 0 || value === 1) {
      return value
    }

    return null
  }

  if (typeof value === 'string') {
    const parsed = Number(value.trim())
    if (parsed === 0 || parsed === 1) {
      return parsed
    }
  }

  return null
}

export function resolveAiWatermarkValueFromPayload(value: unknown) {
  const record = asRecord(value)

  if (!record) {
    return normalizeAiWatermarkValue(value)
  }

  const extraData = asRecord(record.extra_data)
  const extraDataValue = extraData ? normalizeAiWatermarkValue(extraData.ai_watermark) : null

  if (extraDataValue !== null) {
    return extraDataValue
  }

  return normalizeAiWatermarkValue(record.ai_watermark)
}
